/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationCompanySearchCompanyCcnsQuery from '../graphql/queries/GetSimulationCompanySearchCompanyCcnsQuery.js';

const useGetSimulationCompanySearchCompanyCcnsQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationCompanySearchCompanyCcnsQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationCompanySearchCompanyCcns: R.omit(['__typename'], data?.getSimulationCompanySearchCompanyCcns_simulation_company || {})
  };
};

export default useGetSimulationCompanySearchCompanyCcnsQuery;
